import React from 'react';
import Home from './Screens/Home';

function App() {
  return <Home />;
}

export default App;
